import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { ReadOnlyFormGroup, Spinner } from "components/common";
import { Alert, Well } from "components/bootstrap";
import { useLegacyEventNotificationTypes } from "components/event-notifications/hooks/useEventNotifications";
import emailStyles from "../event-notification-types/EmailNotificationSummary.css";
import notificationStyles from "../event-notification-types/LegacyNotificationCommonStyles.css";
const LegacyNotificationDetails = ({ notification }) => {
  const { t } = useTranslation("event_notifications");
  const { data } = useLegacyEventNotificationTypes();
  const legacyTypes = data == null ? void 0 : data.types;
  const configurationValues = notification.config.configuration;
  const callbackType = notification.config.callback_type;
  const typeData = legacyTypes == null ? void 0 : legacyTypes[callbackType];
  if (!legacyTypes) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: t("legacy.loading") }));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !typeData && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: notificationStyles.legacyNotificationAlert }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "legacy.unknown_type",
      values: { title: notification.title || t("legacy.default_title"), callbackType },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  )), typeData && Object.entries(typeData.configuration).map(([key, value]) => {
    if (key === "body" || key === "script_args") {
      return /* @__PURE__ */ React.createElement(
        ReadOnlyFormGroup,
        {
          key,
          label: value.human_name,
          value: /* @__PURE__ */ React.createElement(Well, { bsSize: "small", className: emailStyles.bodyPreview }, configurationValues[key] || /* @__PURE__ */ React.createElement("em", null, t("email_summary.empty_body")))
        }
      );
    }
    return /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { key, label: value.human_name, value: configurationValues[key] });
  }));
};
export default LegacyNotificationDetails;
